<div class="header-bar">
  <h1>Incident Administration</h1>
</div>
<div class="content-container">
  <div>
    <p-table
      #dataTable
      [lazy]="false"
      [paginator]="false"
      [responsive]="true"
      [value]="incidentTypes"
      resizableColumns="true"
      rowHover="true"
      selectionMode="none"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="shrink-cell"></th>
          <th pSortableColumn="name">Incident Type</th>
          <th pSortableColumn="inactiveTimeStamp" class="date-cell">Inactive Date</th>
          <th>Auto Assignment</th>
          <th class="autoclose-cell">Auto-close</th>
          <th class="open-cell">Open Incidents</th>
          <th>Reassign To</th>
          <th>Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td class="shrink-cell text-center">
            <span (click)="deactivateIncidentType(item)" *ngIf="!item.inactiveTimeStamp"
              ><i class="fa ui-icon-lock" pTooltip="Deactivate incident type"></i>
            </span>
            <span (click)="reactivateIncidentType(item)" *ngIf="item.inactiveTimeStamp">
              <i class="fa ui-icon-lock-open" pTooltip="Reactivate incident type"></i>
            </span>
          </td>
          <td>
            <div pTooltip="{{ item.name }}">{{ item.name }}</div>
          </td>
          <td class="text-center date-cell">
            <div *ngIf="item.inactiveTimeStamp">
              {{ item.inactiveTimeStamp | date : 'dd/MM/yyy HH:mm' }}
            </div>
            <div *ngIf="!item.inactiveTimeStamp"></div>
          </td>
          <td class="text-center">
            <div
              *ngFor="let assignee of item.incidentTypeServiceGroupAssignees"
              style="margin-bottom: 8px; white-space: nowrap; overflow: hidden"
            >
              <span
                (click)="deleteAssignee(item, assignee)"
                pTooltip="Delete Assignee"
                style="margin-right: 5px"
              >
                <i class="fa fa-lg fa-trash-o" style="color: red"></i>&nbsp;
              </span>

              <span
                style="margin-top: auto; margin-bottom: auto"
                [pTooltip]="
                  assignee.autoAssigneeUserName +
                  (assignee.serviceDeliveryGroupName
                    ? '(' + assignee.serviceDeliveryGroupName + ')'
                    : '')
                "
                tooltipPosition="top"
              >
                {{ assignee.autoAssigneeUserName }}
                <span *ngIf="assignee.serviceDeliveryGroupName">
                  ({{ assignee.serviceDeliveryGroupName }})
                </span>
              </span>
            </div>

            <div class="text-center style2023">
              <button
                (click)="addAssignee(item)"
                class="btn-xs mt-0"
                icon="fa ui-icon-plus"
                style="line-height: 13px"
                label="Assignee"
                pButton
                pTooltip="Add New Assignee"
                type="button"
              ></button>
            </div>
          </td>
          <td class="text-center">
            <p-checkbox
              [(ngModel)]="item.autoClose"
              id="autoClose"
              binary="true"
              (click)="setAutoClose(item)"
            ></p-checkbox>
          </td>
          <td>
            <div class="open-incidents">{{ item.openIncidentsCount }}</div>
          </td>
          <td>
            <p-dropdown
              (onChange)="setReassignUser(item, $event)"
              *ngIf="item.openIncidentsCount > 0"
              [options]="assigneesOptions"
              appendTo="body"
              placeholder="Not Assigned"
              [filter]="true"
            ></p-dropdown>
          </td>
          <td>
            <span *ngIf="assigningIncidentType == item">
              <span class="search-spinner"
                ><img alt="Loading" height="30" src="assets/images/loader.gif" width="30"
              /></span>
            </span>
            <a
              pTooltip="Assign Open Incidents to 'Reassigned' user"
              (click)="assignOpenIncidents($event, item)"
              *ngIf="item.openIncidentsCount > 0 && !assigningIncidentType && item.reassignUser"
              >Assign</a
            >
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog
  [(visible)]="showAssigneeDialog"
  [closable]="false"
  [modal]="true"
  [responsive]="true"
  [style]="{ width: '750px' }"
>
  <p-header>
    <div style="font-size: 0.9rem; font-style: oblique">{{ selectedIncidentType?.name }}</div>
  </p-header>

  <div class="grid">
    <div class="col-2 dialog-label">
      <label for="newSdGroup">Service Group:</label>
    </div>
    <div class="col-4">
      <p-dropdown
        [(ngModel)]="newGroupAssignment.serviceDeliveryGroupId"
        [options]="assignableServiceGroups"
        [style]="{ width: '100%' }"
        [disabled]="!newGroupAssignment.isNew"
        appendTo="body"
        autoWidth="false"
        id="newSdGroup"
        placeholder="Select a Service Delivery Group"
      ></p-dropdown>
    </div>

    <div class="col-2">
      <label for="newAssignee">Assignee:</label>
    </div>
    <div class="col-4 dialog-label" style="padding: 0 10px 0 0">
      <p-dropdown
        [(ngModel)]="newGroupAssignment.assigneeId"
        [options]="serviceGroupAssignees.get(newGroupAssignment.serviceDeliveryGroupId)"
        [style]="{ width: '100%' }"
        appendTo="body"
        autoWidth="false"
        id="newAssignee"
        placeholder="Select a User"
        [filter]="true"
      ></p-dropdown>
    </div>
  </div>

  <div style="float: right; margin-top: 50px">
    <button (click)="setAssignee()" class="green-btn" label="Save" pButton type="button"></button>
    <button
      (click)="showAssigneeDialog = false"
      icon="fa ui-icon-close"
      label="Close"
      pButton
      type="button"
    ></button>
  </div>
</p-dialog>
